var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (continueBtnText, doneText, hasNarration, hasPrompt, i18n, prompt, submitUp, undefined, url, waypoints) {
jade_mixins["image"] = jade_interp = function(imageUrl, klass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<img" + (jade.attr("src", imageUrl, true, false)) + (jade.cls([klass], [true])) + "/>");
};
buf.push("<div class=\"content-fill text-center block-v-md\"><div class=\"image-container block-inline content-fill\">");
jade_mixins["image"](url, 'img-map content-ver');
buf.push("<div class=\"waypoints content\">");
// iterate waypoints
;(function(){
  var $$obj = waypoints;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var w = $$obj[i];

buf.push("<div" + (jade.attr("style", ([
            "left: " + (w.region.xMin * 100) + "%",
            "top: " + (w.region.yMin * 100) + "%",
            "width: " + ((w.region.xMax - w.region.xMin) * 100) + "%",
            "height: " + ((w.region.yMax - w.region.yMin) * 100) + "%"
          ].join(";")), true, false)) + (jade.attr("data-index", i, true, false)) + " class=\"waypoint\"></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var w = $$obj[i];

buf.push("<div" + (jade.attr("style", ([
            "left: " + (w.region.xMin * 100) + "%",
            "top: " + (w.region.yMin * 100) + "%",
            "width: " + ((w.region.xMax - w.region.xMin) * 100) + "%",
            "height: " + ((w.region.yMax - w.region.yMin) * 100) + "%"
          ].join(";")), true, false)) + (jade.attr("data-index", i, true, false)) + " class=\"waypoint\"></div>");
    }

  }
}).call(this);

buf.push("</div></div></div>");
// iterate waypoints
;(function(){
  var $$obj = waypoints;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var w = $$obj[i];

buf.push("<div class=\"waypoint-img content-fill text-center\">");
jade_mixins["image"](w.image, 'content-ver');
buf.push("</div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var w = $$obj[i];

buf.push("<div class=\"waypoint-img content-fill text-center\">");
jade_mixins["image"](w.image, 'content-ver');
buf.push("</div>");
    }

  }
}).call(this);

buf.push("<div class=\"full-screen\"><div class=\"navigation text-center\"><div class=\"caption text-md block-lg\"></div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined,"url" in locals_for_with?locals_for_with.url:typeof url!=="undefined"?url:undefined,"waypoints" in locals_for_with?locals_for_with.waypoints:typeof waypoints!=="undefined"?waypoints:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}